/**
 * Turbo Manager - BRONCANO  
 * Maneja la navegación PJAX con Turbo.js
 */

document.addEventListener('DOMContentLoaded', function() {
    initializeTurboNavigation();
});

function initializeTurboNavigation() {
    // Configurar navegación PJAX si Turbo está disponible
    if (typeof Turbo !== 'undefined') {
        // Configurar eventos de Turbo
        document.addEventListener('turbo:load', function() {
            // Reinicializar animaciones después de navegación PJAX
            if (typeof setupIntersectionObservers === 'function') {
                setupIntersectionObservers();
            }
            
            // Reinicializar otros scripts
            initializePageScripts();
        });

        document.addEventListener('turbo:before-visit', function() {
            // Limpiar antes de navegar
            cleanupCurrentPage();
        });
    } else {
        // Fallback sin Turbo
        console.log('Turbo no disponible, usando navegación estándar');
        initializePageScripts();
    }
}

function initializePageScripts() {
    // Inicializar scripts específicos de la página
    initializeAnimations();
    setupNavigation();
}

function initializeAnimations() {
    // Activar animaciones CSS para elementos específicos
    const elementsToAnimate = document.querySelectorAll('.wasp-hex-item');
    
    elementsToAnimate.forEach((element, index) => {
        setTimeout(() => {
            element.classList.add('animate-in');
        }, index * 150);
    });
}

function setupNavigation() {
    // Configurar navegación suave para enlaces internos
    const navLinks = document.querySelectorAll('a[href^="#"]');
    
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

function cleanupCurrentPage() {
    // Limpiar eventos y animaciones antes de cambiar de página
    const runningAnimations = document.querySelectorAll('.animate-in');
    runningAnimations.forEach(element => {
        element.classList.remove('animate-in');
    });
}